import { apiEndpoint } from '../../_config/config'
import { handleResponse } from '../../_helpers'
import axios from 'axios'
import { localForageService } from '../../_helpers/localforageService'

export const page = {
  namespaced: true,
  state: {
    page: {},
    error: {},
    loading: false
  },
  actions: {
    get ({ commit }, { path }) {
      commit('SET_LOADING', true)
      if (path.length === 4) {
        // Remove last / in the case that there is only a language (/nl/ or /en/)
        path = path.substring(0, 3)
      }

      const config = {
        method: 'GET',
        url: `${apiEndpoint}/api/frontend/page${path}`
      }

      try {
        localForageService.getItem(path).then((save) => {
          commit('SET_PAGE', save)
        })
      } catch (e) {
        console.log('Error: ', e)
      }

      axios(config).then(handleResponse)
        .then(
          response => {
            // console.log(response)
            if (typeof response[0] !== 'undefined') {
              commit('SET_PAGE', response[0].result)

              try {
                localForageService.setItem(path, response[0].result)
              } catch (e) {
                console.log('Error: ', e)
              }
            }
            commit('SET_LOADING', false)
          },
          error => {
            commit('SET_ERROR', error)
            commit('SET_LOADING', false)
          }
        )
    }
  },
  mutations: {
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_PAGE (state, data) {
      state.page = data
    },
    SET_ERROR (state, error) {
      state.error = error
    }
  },
  getters: {
    getPage: state => {
      return state.page
    },
    getPageLoading: state => {
      return state.loading
    }
  }
}
